(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sahara-curated-home"] && !Shopify.designMode) return;
  try {
    
  function prepareSaharaCarousels() {
    document.querySelectorAll('[data-sahara-carousel]').forEach((section) => {
      const slideshow = section.querySelector('slideshow-component');
      if (!slideshow || section.dataset.motionReady) return;
      section.dataset.motionReady = 'true';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pause = () => slideshow.pause();
      if (motion.matches) pause();
      motion.addEventListener('change', (event) => { if (event.matches) pause(); });
      section.addEventListener('focusin', pause);
    });
  }
  customElements.whenDefined('slideshow-component').then(prepareSaharaCarousels);
  document.addEventListener('shopify:section:load', prepareSaharaCarousels);

  } catch(e) { console.error(e); }
})();
})();
